export default () => 
<div className='columns is-centered' >
    <h1 className="is-size-3">404</h1>
</div>
